module.exports = __webpack_public_path__ + "img/none.09970dbb.png";